import { type ReactNode, useCallback } from "react";
import "./ThreeStatesCheckbox.scss";
import type {
  IconAlignment,
  Size,
} from "@/shared/components/generic/UiEnums.ts";
import Checkbox from "@/shared/components/generic/checkbox/Checkbox.tsx";
import classNames from "classnames";
import type {
  NoneAll,
  NoneSomeAll,
} from "@/shared/components/generic/checkbox/model/ThreeStateCheckboxHelper.ts";

interface Properties {
  alignIcon?: IconAlignment;
  state: NoneSomeAll;
  onChange: (state: NoneAll) => void;
  size?: Size;
  disabled?: boolean;
  label: string;
}

export default function ThreeStatesCheckbox(props: Properties): ReactNode {
  const toggleNoneAll = useCallback(() => {
    props.onChange(props.state === "all" ? "none" : "all");
  }, [props]);
  return (
    <div
      className={classNames(
        "three-states-checkbox",
        props.state === "some" && "state-some",
      )}
      onClick={toggleNoneAll}
    >
      <Checkbox
        alignIcon={props.alignIcon}
        onChange={toggleNoneAll}
        size={props.size}
        selected={props.state !== "none"}
        disabled={props.disabled}
        item={{ key: "three_state_checkbox", label: props.label }}
      />
    </div>
  );
}
